import React from 'react';
import { Star } from 'lucide-react';
import styles from './Testimonios.module.css';

export const TestimonioTarjeta = ({ name, role, company, content, rating = 5, image }) => {
  return (
    <div className={styles.tarjeta}>
      <div className={styles.comillas}>"</div>

      <div className={styles.contenido}>
        {rating > 0 && (
          <div className={styles.estrellas}>
            {Array.from({ length: 5 }).map((_, index) => (
              <Star
                key={index}
                size={16}
                className={index < rating ? styles.estrellaLlena : styles.estrellaVacia}
              />
            ))}
          </div>
        )}

        <p className={styles.textoResena}>{content}</p>

        <div className={styles.perfilContenedor}>
          <div className={styles.perfilInfo}>
            {image ? (
              <img src={image} alt={name} className={styles.avatar} referrerPolicy="no-referrer" />
            ) : (
              <div className={styles.avatarFallback}>{name ? name[0].toUpperCase() : 'S'}</div>
            )}
            
            <div className={styles.detallesUsuario}>
              <h3 className={styles.nombreUsuario}>{name}</h3>
              <p className={styles.rolUsuario}>
                {role}
                {company && ` @ ${company}`}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
